import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, ButtonText, Modal } from '@morressier/alembic';
import { IActivityLog } from '@publishing-engine/domain/models';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive } from '@fortawesome/pro-light-svg-icons';

type Props = {
  data: IActivityLog['eventPayload'];
};

const ReversalContextModal = ({
  onClose,
  data
}: Props & { onClose: () => void }) => {
  const { reason, previousPhase, currentPhase } = data || {};

  return (
    <Modal
      isOpen
      closeButtonProps={{
        hidden: true
      }}
      onClose={onClose}
      width="720px"
    >
      <Flex
        padding={8}
        gap={6}
        flexDirection="column"
        maxHeight="80vh"
        overflow="auto"
      >
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faArchive} />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Reversal Context</Text>
          <Text textStyle="textBody">
            This submission was reverted from {previousPhase} to {currentPhase}{' '}
            due to the following reasons:
          </Text>
        </Flex>

        <Flex gap={2} flexDirection="column">
          <Text textStyle="headingItem">Reason for Reversal</Text>
          <Text textStyle="textBody">{reason}</Text>
        </Flex>

        <Flex
          gap={2}
          justifyContent="flex-end"
          alignItems="center"
          alignSelf="stretch"
        >
          <Button onClick={onClose} variant="primary" borderRadius="small">
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export const DecisionReverted: React.FC<Props> = ({ data }) => {
  const [show, setShow] = useState(false);

  const onClose = () => setShow(false);

  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'flex-start'}
      gap={2}
    >
      <Text noOfLines={3}>{data?.reason}</Text>
      <ButtonText onClick={() => setShow(true)}>View Full Details</ButtonText>

      {show && <ReversalContextModal data={data} onClose={onClose} />}
    </Flex>
  );
};
